<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Pay Group Collection</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Pay Group Collection: </span>{{ collection.name }}</div>
                </div>
            </div>

            <div v-show="mode == 'name'">
                <div class="form-row">
                    <div class="col">
                        <form-input label="Collection Name" v-model="formData.name" :errors="errors.name" type="text" :maxlength="128" />
                    </div>
                </div>
            </div>

            <div v-if="mode == 'paygroups'">
                <paygroup-selector
                    :client="client"
                    v-model="formData.paygroups"
                />
            </div>

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PaygroupSelector from '@/pages/client/Settings/components/PaygroupSelector'

export default {
    props: ['client', 'collection', 'mode'],
    mixins: [FormMixin, ModalMixin],
    components: {PaygroupSelector},
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {},
    methods: {
        makeFormData() {
            return {
                name: this.collection.name,
                paygroups: this.collection.paygroup_set.map(p => p.id)
            }
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            let data = {}
            const url = `/clients/${this.client.id}/settings/paygroup-collections/${this.collection.id}`
            this.$store.dispatch('START_LOADING')
            if (this.mode == 'name') {
                data = {
                    name: this.formData.name
                }
                this.$api.patch(url, data).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showInfo(`Successfully saved pay group collection.`)
                    this.$emit('updated', resp)
                    this.close()
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.formErrors = (errors.__all__ || [])
                    this.$bus.showError(errors.__all__)
                })
            }
            if (this.mode == 'paygroups') {
                data = {
                    paygroups: this.formData.paygroups
                }
                this.$api.put(url, data).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showInfo(`Successfully saved pay group collection.`)
                    this.$emit('updated', resp)
                    this.close()
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.formErrors = (errors.__all__ || [])
                    this.$bus.showError(errors.__all__)
                })
            }
        }
    }
}
</script>
